class CustomFileInput {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.customFileInput = this.DOM.el.querySelector(`.custom-file-input`);
        this.DOM.customFileLabel = this.DOM.el.querySelector(`.custom-file-label`);

        this.initEvents();
    }

    initEvents() {
        this.DOM.customFileInput.addEventListener('change', (event) => {
            const files = Array.from(event.target.files);
            this.DOM.customFileLabel.innerText = files.map(file => file.name).join(", ");
        });
    }
}

const customFileNodes = Array.from(document.querySelectorAll('.custom-file'));
if (customFileNodes !== null) {
    customFileNodes.forEach((node) => { new CustomFileInput(node); });
}
